import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=6fd2ab58&scoped=true"
import script from "./alerts.vue?vue&type=script&lang=js"
export * from "./alerts.vue?vue&type=script&lang=js"
import style0 from "./alerts.vue?vue&type=style&index=0&id=6fd2ab58&prod&scoped=true&lang=scss"
import style1 from "./alerts.vue?vue&type=style&index=1&id=6fd2ab58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2ab58",
  null
  
)

export default component.exports